import Auth from "@aws-amplify/auth";

export async function Init(): Promise<void> {
  const config = {
    stage: "beta",
    aws_cognito_region: "ap-southeast-2",
    aws_cognito_identity_pool_id: "ap-southeast-2:ec6c65f5-584f-4f89-b356-034efb990ac4",
    aws_user_pools_id: "ap-southeast-2_4Ori9pfhq",
    aws_user_pools_web_client_id: "1bbjlugmm38l67lt6ona97ek43",
    Auth: {
      identityPoolId: "ap-southeast-2:ec6c65f5-584f-4f89-b356-034efb990ac4",
      region: "ap-southeast-2",
      userPoolId: "ap-southeast-2_4Ori9pfhq",
      userPoolWebClientId: "1bbjlugmm38l67lt6ona97ek43",
    },
    oauth: {
      domain: `whs-safer-beta-in.auth.us-east-1.amazoncognito.com`,
      redirectSignIn: "https://beta.in.safer.whs.amazon.dev",
      redirectSignOut: "https://beta.in.safer.whs.amazon.dev",
      scope: ["openid", "profile"],
      responseType: "code",
    },
  };
  Auth.configure(config);
}
